import { useLoaderData, useLocation } from '@remix-run/react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import PlentyBody from '#app/components/typography/plenty-body'
import PlentyHeading from '#app/components/typography/plenty-heading'
import { Icon } from '#app/components/ui/icon'
import useAmplitudeContext from '#app/hooks/use-amplitude-context'
import { type loader } from '#app/routes/_public+/products+/$slug'

const NoProductsFound = () => {
	const location = useLocation()
	let { t } = useTranslation('product_list_page')
	const { trackAmplitudeEvent } = useAmplitudeContext()
	const data = useLoaderData<typeof loader>()
	const { categoriesData } = data
	const pathParts = location.pathname.split('/')
	const categoryKey = pathParts[2] || ''
	const urlParams = new URLSearchParams(location.search)
	const isEmptyCategory = urlParams.get('empty-category') === 'true'

	const currentCategory = categoriesData.result.find(
		(category: any) => category.id === categoryKey,
	)

	useEffect(() => {
		isEmptyCategory &&
			trackAmplitudeEvent('store selector products not found', {
				currentCategory: currentCategory.name,
			})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return isEmptyCategory ? (
		<div className="mt-2 flex flex-col items-center justify-center space-y-4 bg-beige-50 px-4 py-6 md:px-32">
			<PlentyBody>
				{t('store_selector_not_found_products_message_title', {
					category: currentCategory.name,
				})}
			</PlentyBody>
			<div className="flex flex-row space-x-1">
				<PlentyHeading as="h7">
					{t('store_selector_not_found_products_message_heading')}
				</PlentyHeading>
				<Icon name="right-arrow" className="rotate-90" size="lg" />
			</div>
		</div>
	) : null
}

export default NoProductsFound
